import { useAtom } from "@reatom/npm-react";
import { CreateExportTaskRequestDto } from "definitions/exporter";
import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import Select, { PropsValue } from "react-select";
import { SELECT_STYLES } from "src/constants/selectStyle";
import { getProductSamplesRequest } from "src/pages/ProductPage/widgets/ProductSamples/store/fetchers";
import { OptionType } from "src/types";

export const ProductSampleForm = () => {
  const { control, watch } = useFormContext<CreateExportTaskRequestDto>();
  const selectProductSampleId = watch("selectProductSampleId");

  const [productSamples] = useAtom(getProductSamplesRequest.dataAtom);

  const options: OptionType[] = useMemo(
    () =>
      productSamples.map((productSample) => ({
        label: productSample.name,
        value: productSample.id.toString(),
      })),
    [productSamples],
  );

  const currentValue: PropsValue<OptionType> = useMemo(() => {
    const currentSample = productSamples.find(
      (sample) => sample.id === selectProductSampleId,
    );

    if (!currentSample) return null;

    return { label: currentSample.name, value: currentSample.id.toString() };
  }, [productSamples, selectProductSampleId]);

  return (
    <Controller
      name="selectProductSampleId"
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          isClearable
          isMulti={false}
          value={currentValue}
          styles={SELECT_STYLES}
          onChange={(newValue) => {
            if (newValue) return field.onChange(Number(newValue.value));

            field.onChange("");
          }}
          placeholder="Название выборки"
          options={options}
          noOptionsMessage={({ inputValue }) =>
            `Выборка "${inputValue}" не найдена`
          }
        />
      )}
    />
  );
};
